import { HANDLE_LANGUAGE_CHANGE } from '../constants/action-types';

export const handleLanguageChange = (lang) => {
  return {
    type: HANDLE_LANGUAGE_CHANGE,
    data: lang,
  };
};
